import axios from 'axios';

// const BASE_URL = 'http://your-api-url'; // Replace with your API base URL
// console.log(props.State);
const appUrl = "http://feedback.savourfoods.com.pk"; // Live App URL
const BASE_URL = "http://182.176.94.28:88"; // Live API UR
// const appUrl = "http://localhost:3000"; // Local App URL
// const BASE_URL = "http://localhost:38666"; // Local API URL

const headers = {
    'Content-Type': 'multipart/form-data',
    'Authorization': 'nE0A8Um109Yrv0BHbf0BEpWd0aB0EqxvnDSfUnVwryqHFbc2+sxfwsjQssLRXKud',
    'Access-Control-Allow-Origin': appUrl,
    'Access-Control-Allow-Methods': 'GET, POST',
    'Access-Control-Allow-Headers': 'Content-Type, Authorization',
    'Access-Control-Allow-Credentials': 'true'
}
const getNoParams = async (url) => {
  try {
    debugger;
      const response = await axios.get(`${BASE_URL}/${url}`, { headers });
    return response.data;
  } catch (error) {
    throw error;
  }
};
const get = async (url, params = {}) => {
  try {
    const response = await axios.get(`${BASE_URL}/${url}`, { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const post = async (url, data) => {
  try {
    const response = await axios.post(`${BASE_URL}/${url}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export { get, getNoParams, post };